/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChallenge } from '../../../../../pages/ChallengeDetails/Context';
import { useNumberFormat } from '../../../../../hooks/numberFormat';
import Trophy from '../../../../Svg/Trophy';

import * as S from '../style';

const SurviveWithWrong = ({ typePrize, myResult }) => {
  const { t } = useTranslation();

  const { currencySymbol, moneyIntl } = useNumberFormat();

  const {
    challenge: { resultPrize, otherPrizeDescriptionSingular },
  } = useChallenge();

  if (!['Survive', 'Awarded'].includes(myResult)) {
    return <S.TitleColor>{t('round.button.endGame')}</S.TitleColor>;
  }

  let currencyValue = resultPrize.unitPrizeSurvive.float;

  if (myResult === 'Awarded') {
    currencyValue = resultPrize.unitPrizeWrong.float;
  }

  return (
    <>
      <S.SubtitleMessageColor>
        {t('round.message.title.win')}
      </S.SubtitleMessageColor>

      {myResult === 'Survive' && typePrize === 'Other' ? (
        <S.GroupCurrency>
          <S.CurrencyValue>1 {otherPrizeDescriptionSingular}</S.CurrencyValue>
        </S.GroupCurrency>
      ) : (
        <S.GroupCurrency>
          <S.CurrencySymbol>{currencySymbol()}</S.CurrencySymbol>
          <S.CurrencyValue>
            {moneyIntl(currencyValue, {
              digits: 1,
            })}
          </S.CurrencyValue>
        </S.GroupCurrency>
      )}
      <S.IconBg size={100}>
        <Trophy width={65} height={65} />
      </S.IconBg>
    </>
  );
};

export default SurviveWithWrong;
